import { queryClient } from '@/shared/api/queryClient'
import { postToHost } from '@/shared/bridge/bridge'
import { usesHostSession } from '@/shared/bridge/env'
import { useAuthStore } from '@/shared/store/authStore'
import { navigateToLogin } from '@/shared/lib/navigateToLogin'

export function logoutLocally(redirect = true) {
  const embedded = usesHostSession()
  useAuthStore.getState().logout()
  queryClient.clear()
  if (embedded) {
    postToHost({ type: 'LOGOUT' })
    return
  }
  if (redirect) void navigateToLogin('logout')
}
